import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['Horas planificando cada clase', 'Clases repetitivas', 'Sin progresión real', 'Miedo ante una lesión', 'Alumnos que no avanzan'];
const after = ['5 minutos de preparación', 'Clases con variedad', 'Progresión clara por nivel', 'Protocolo para cada caso', 'Alumnos que renuevan'];
const facts = [{
  value: '52',
  label: 'Semanas'
}, {
  value: '12',
  label: 'Tomos'
}, {
  value: '100%',
  label: 'Descargable'
}];
export function TransformationSection() {
  return <section className="py-16 md:py-24 px-5 bg-surface-light" data-id="element-216" data-mp="2e7xn1onnrmyx">
      <div className="max-w-6xl mx-auto" data-id="element-217" data-mp="298l2jak9erzi">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-start" data-id="element-218" data-mp="299mctctgbag6">
          {/* Headline + highlight stat */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-219" data-mp="24b2v5olw4ktm">
            <h2 className="font-display font-black text-primary text-3xl md:text-5xl leading-[1.1] tracking-tight mb-8" data-id="element-220" data-mp="5do3n8ujr8me">
              De un instructor sobrecargado a una{' '}
              <em className="italic font-bold text-accent" data-id="element-221" data-mp="y1todvlloxm8">guía inspirada.</em>
            </h2>

            <div className="bg-white rounded-2xl border border-primary/5 shadow-sm p-6 md:p-8 flex items-center gap-6 max-w-md" data-id="element-222" data-mp="130n6y2fqvet9">
              <span className="font-display font-black text-accent text-4xl md:text-5xl leading-none whitespace-nowrap" data-id="element-223" data-mp="p1nhwtobkxwk">
                5 min
              </span>
              <p className="text-sm md:text-base text-primary/65 leading-relaxed" data-id="element-224" data-mp="39r4gr5xlsy9u">
                para dejar tu clase lista, en vez de una hora entera.
              </p>
            </div>
          </motion.div>

          {/* Before / After card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-3xl overflow-hidden shadow-sm border border-primary/5 grid sm:grid-cols-2" data-id="element-225" data-mp="1k8o21m2px1ks">
            <div className="bg-white p-6 md:p-8" data-id="element-226" data-mp="wk54o1l7i97h">
              <div className="flex items-center gap-2.5 mb-6" data-id="element-227" data-mp="wmhj44rra1fs">
                <span className="w-6 h-6 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0" data-id="element-228" data-mp="rmd0a83dkume">
                  <XIcon className="w-3.5 h-3.5 text-accent" data-id="element-229" data-mp="mns20e7ool0l" />
                </span>
                <span className="text-sm font-bold uppercase tracking-wider text-accent" data-id="element-230" data-mp="2ly1kaoogrndn">
                  Antes
                </span>
              </div>
              <ul className="space-y-4" data-id="element-231" data-mp="2ph8t6c2z0yp0">
                {before.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-232" data-mp="2pffsreiybapg">
                    <XIcon className="w-4 h-4 text-accent/70 flex-shrink-0 mt-0.5" data-id="element-233" data-mp="2thaugk4snq3r" />
                    <span className="text-sm md:text-base text-primary/60" data-id="element-234" data-mp="2yavjhmoet9qt">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-surface-accent/60 p-6 md:p-8 border-t sm:border-t-0 sm:border-l border-primary/5" data-id="element-235" data-mp="26jz5ujuiz12h">
              <div className="flex items-center gap-2.5 mb-6" data-id="element-236" data-mp="2ak9mcqfy19vl">
                <span className="w-6 h-6 rounded-full bg-[#6F8A63]/15 flex items-center justify-center flex-shrink-0" data-id="element-237" data-mp="2fi1cpg0xwnxo">
                  <CheckIcon className="w-3.5 h-3.5 text-[#5F7A54]" data-id="element-238" data-mp="2kjqr95ndfjqi" />
                </span>
                <span className="text-sm font-bold uppercase tracking-wider text-primary" data-id="element-239" data-mp="3qxga2kx29htb">
                  Con Stretching 360
                </span>
              </div>
              <ul className="space-y-4" data-id="element-240" data-mp="18odc3guo11r0">
                {after.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-241" data-mp="13q21h3wjqn7q">
                    <CheckIcon className="w-4 h-4 text-[#5F7A54] flex-shrink-0 mt-0.5" data-id="element-242" data-mp="13rvc0uaa5rl0" />
                    <span className="text-sm md:text-base font-semibold text-primary" data-id="element-243" data-mp="1hqv0o1xsm6h6">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Fact cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-10 md:mt-16" data-id="element-244" data-mp="1mnv6cbqqd77r">
          {facts.map((fact, index) => <motion.div key={fact.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white rounded-2xl border border-primary/5 shadow-sm py-8 px-6 text-center" data-id="element-245" data-mp="20i5qefrs8d7h" data-mpi={index}>
              <div className="font-display font-black text-primary text-3xl md:text-4xl leading-none mb-2" data-id="element-246" data-mp="2f3jfhyy32kds">
                {fact.value}
              </div>
              <div className="text-[0.7rem] md:text-xs font-semibold uppercase tracking-[0.12em] text-primary/60" data-id="element-247" data-mp="2k3nzhyy79x8r">
                {fact.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}